import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuditLanding, AuditDiagnostic, AuditReport } from "./audit/AuditApp";
import { AdminConsole } from "./admin/AdminApp";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AuditLanding />} />
        <Route path="/diagnostic" element={<AuditDiagnostic />} />
        <Route path="/rapport/:id" element={<AuditReport />} />
        <Route path="/admin" element={<AdminConsole />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
